module.exports = __webpack_public_path__ + "static/media/offices-tag-icon.7223daf2.svg";